import { Message } from "@adfenix/alexandria";
import Page from "./Page";
import { useTranslation } from "react-i18next";

export const GenericError = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <Message type="error">{t("order.error.generic.title")}</Message>
    </Page>
  );
};
